module.exports = __webpack_public_path__ + "img/c01_unitstartechspearmanchampion_Normal_ua.c0d02ec3.webp";